module.exports = __webpack_public_path__ + "static/media/plan.7b6fcaa3.svg";